export function applyAnimationDelayPerIndex<T>(node: T): T {
    if (Array.isArray(node)) {
        return node.map((item) => applyAnimationDelayPerIndex(item)) as unknown as T;
    }
    if (typeof node !== 'object' || node === null) return node;

    const result: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(node)) {
        if (key !== 'animationDelayPerIndex') {
            result[key] = applyAnimationDelayPerIndex(value);
        } else if (typeof value === 'number' && Number.isFinite(value)) {
            result.animationDelay = (idx: number) => idx * value;
        }
    }
    return result as T;
}
